import { inject, ref, computed } from 'vue';
import { useStore } from 'vuex';

export function useCollectionFilter() {
  const store = useStore();
  const permission_mes = computed(() => {
    return store.state.user_data?.permission_list?.messagesAndAnnouncements;
  });

  const merchantChatroom = computed(() => {
    return store.state.user_data.merchant_account.is_enable_chatroom;
  });
  const backFlagList = [
    { name: 'High', id: 100 },
    { name: 'Medium', id: 50 },
    { name: 'Low', id: 10 },
    { name: 'None', id: 0 },
  ];

  const BackPostStatusList = [
    { name: 'Active', id: 100, clientUseText: 'reactivated' },
    { name: 'Disabled', id: 70, clientUseText: 'disabled' }, //creator can not activate this post
    { name: 'Hidden', id: 60, clientUseText: 'hid' },
    { name: 'Deleted', id: 5, clientUseText: 'deleted' },
    { name: 'Disabled', id: 65, clientUseText: 'disabled' }, //Archvied
  ];

  //5(deleted),60(inactive),70(disable),100(active)
  const statusList = ref([
    { name: 'All', value: 0, show: true, keyword: '', field_name: 'content_status' },
    { name: 'Active', value: 1, show: true, keyword: 100, field_name: 'content_status' },
    { name: 'Inactive', value: 2, show: true, keyword: 60, field_name: 'content_status' },
    { name: 'Archvied', value: 3, show: true, keyword: 65, field_name: 'content_status', not_show: true },
    { name: 'Disabled', value: 4, show: true, keyword: 70, field_name: 'content_status' },
    { name: 'Deleted', value: 5, show: true, keyword: 5, field_name: 'content_status' },
  ]);

  //tiktok,instagram,image,youtube,collection
  const typeList = ref([
    { name: 'All', value: 0, show: true, keyword: '', field_name: 'collection_type' },
    { name: 'TikTok', value: 1, show: true, keyword: 'tiktok', field_name: 'collection_type' },
    { name: 'Instagram', value: 2, show: true, keyword: 'instagram', field_name: 'collection_type' },
    { name: 'YouTube', value: 3, show: true, keyword: 'youtube', field_name: 'collection_type' },
    { name: 'Original', value: 4, show: true, keyword: 'image', field_name: 'collection_type' },
  ]);

  //0,10,50,100
  const flagList = ref([
    { name: 'All', value: 0, show: true, keyword: 0, field_name: 'flag_status' },
    { name: 'Low', value: 1, show: true, keyword: 10, field_name: 'flag_status' },
    { name: 'Medium', value: 2, show: true, keyword: 50, field_name: 'flag_status' },
    { name: 'High', value: 3, show: true, keyword: 100, field_name: 'flag_status' },
  ]);

  //active,100,disabled,0
  const creatorStausList = ref([
    { name: 'All', value: 0, show: true, keyword: '' },
    { name: 'Active', value: 1, show: true, keyword: 'active', field_name: 'anchor_status' },
    { name: 'Inactive', value: 2, show: true, keyword: 'disabled', field_name: 'anchor_status' },
  ]);

  const callApiTypeId = (val) => {
    return val === 'post' ? 10 : 20;
  };

  const makeCollectionItem = (item, vi) => {
    // console.log('item.contentModertaion', item);

    item.status = {};
    let val = item.contentModertaion ? item.contentModertaion : item;

    if (val.status === BackPostStatusList[0].id) {
      item.status = { name: val.status_name, color: 'green' };
      item.is_active = true;
      item.is_disabled = false;
      item.is_archvied = false;
    } else if (val.status === BackPostStatusList[1].id) {
      item.status = { name: val.status_name, color: 'red' };
      item.is_disabled = true;
      item.is_active = false;
    } else if (val.status === BackPostStatusList[2].id) {
      item.status = { name: val.status_name, color: 'normal' };
      item.is_hidden = true;
    } else if (val.status === BackPostStatusList[3].id) {
      item.status = { name: val.status_name, color: 'red' };
      item.is_deleted = true;
    } else if (val.status === BackPostStatusList[4].id) {
      item.status = { name: 'Disabled', color: 'red' };
      item.is_archvied = true;
      item.is_active = false;
    }

    if (item.is_hidden || item.is_deleted) {
      item.can_not_edit = true;
    }

    item.flag = {};
    if (val.flag_status === backFlagList[3].id || !val.flag_status) {
      item.flag = { icon: 'flag-2', color: 'normal' };
    } else {
      item.flag = { icon: 'flag-color', color: flagColor(val.flag_status) };
    }
  };

  const makeCollectionBadage = (item, vi) => {
    item.badage = [];

    //temp
    if (item.type === 'post') {
      if (item.media_type === 'App\\TikTokVideo') {
        item.badage.push({ name: 'TikTok', color: 'normal' });
      }

      if (item.media_type === 'App\\InstagramMedia') {
        item.badage.push({ name: 'Instagram', color: 'normal' });
      }

      if (item.media_type === 'App\\YoutubeVideo') {
        item.badage.push({ name: 'YouTube', color: 'normal' });
      }

      if (item.media_type === 'App\\NativePhoto') {
        item.badage.push({ name: 'Image', color: 'normal' });
      }
    }

    if (item.is_feature) {
      item.badage.push({ name: 'Featured', color: 'yellow', is_feature: true });
    }
  };

  const makeHistoryTitle = (val, type, user) => {
    //operate_type
    //10=status
    //20=flag
    //30=read
    let name = val.operator_name;
    //
    let statusClientText = BackPostStatusList.find((item) => item.id == val.new_value)?.clientUseText || 'updated';

    switch (val.operate_type) {
      case 10:
        return `<span class='strong-span'>${name}</span> ${statusClientText} this ${type} ${
          val.is_sent_to_chatroom ? `and sent a note to <span class='strong-span'>${user}</span>` : ``
        }`;
      case 20:
        if (val.new_value == '0') {
          return `<span class='strong-span'>${name}</span> resolved this ${type} and sent to <span class='strong-span'>${user}</span>`;
        } else {
          return `<span class='strong-span'>${name}</span> flagged this ${type} and sent to <span class='strong-span'>${user}</span>`;
        }
      case 30:
        return `<span class='strong-span'>${name}</span> read this ${type}`;
      case 50:
        return `<span class='strong-span'>${name}</span> created a ${type} on their storefront`;
      case 51:
        return `<span class='strong-span'>${name}</span> created a ${type} on their storefront`;
      case 60:
        return `<span class='strong-span'>${name}</span> ${statusClientText} this ${type}`;
      case 65:
        return `<span class='strong-span'>${name}</span> unhide this ${type}`;
      case 41:
        return `<span class='strong-span'>${name}</span> added a product`;
      case 42:
        return `<span class='strong-span'>${name}</span> removed a product`;
      case 43:
        return `<span class='strong-span'>${name}</span> updated the collection name`;
      case 44:
        return `<span class='strong-span'>${name}</span> updated the collection description`;
      case 45:
        return `<span class='strong-span'>${name}</span> featured on storefront`;
      case 46:
        return `<span class='strong-span'>${name}</span> unfeatured on storefront`;
      default:
        const reason = val.reason || '';
        const hasStrongSpan = reason.includes('strong-span');
        return hasStrongSpan ? `${reason}` : `<span class='strong-span'>${name}</span> ${reason}`;
    }
  };

  const specialReson = (val) => {
    if (val.operate_type === 40) {
      const prevObj = JSON.parse(val.previous_value);
      const newObj = JSON.parse(val.new_value);
      const result = {};

      if (prevObj.title == undefined) {
        return null;
      } else {
        Object.keys(newObj).forEach((key) => {
          if (prevObj[key] !== newObj[key]) {
            result[key] = newObj[key];
          }
          result[key] = newObj[key] ? newObj[key] : '---';
        });
        return result;
      }
    } else {
      return null;
    }
  };

  const flagColor = (val) => {
    switch (Number(val)) {
      case 100:
        return 'red';
      case 50:
        return 'yellow';
      case 10:
        return 'blue';
      case 0:
        return 'green';
      default:
        return 'normal';
    }
  };

  const statusColor = (val) => {
    switch (Number(val)) {
      case 100:
        return 'green'; //active
      case 70:
        return 'red'; //disabled
      case 65:
        return 'red'; //Archvied
      case 60:
        return 'normal'; //hidden
      case 0:
        return 'red'; //deleted
      default:
        return 'normal';
    }
  };

  const makeHistoryColor = (val) => {
    //creator-> gray
    //edit flag-> flag color
    //disabled -> red
    //unflag || reactivate ||read -> green
    //**"operate_by": 10=>10=MP 20=creator ,=>creator edit always gray**
    if (val.operate_by === 20) {
      return 'gray';
    } else {
      switch (val.operate_type) {
        case 10:
          return statusColor(val.new_value);
        case 20:
          return flagColor(val.new_value);
        case 30:
          return 'green';
        case 40:
          return 'normal-small';
        default:
          return 'normal';
      }
    }
  };

  const canViewMessage = (val) => {
    //50 can view //100can edit
    if (permission_mes.value?.manageMessaging?.permission === 0 || !merchantChatroom.value) {
      return false;
    } else {
      if (!val.is_sent_to_chatroom) {
        return false;
      } else {
        return true;
      }
    }
  };

  return {
    statusList,
    typeList,
    flagList,
    creatorStausList,
    makeCollectionBadage,
    makeCollectionItem,
    makeHistoryTitle,
    flagColor,
    makeHistoryColor,
    callApiTypeId,
    canViewMessage,
    specialReson,
  };
}
